<template>
  <div>
    <div>
      <router-link to="/">
        <img src="@/assets/home.png" width="32px" height="32px" />
      </router-link>
    </div>
    <div v-if="isValid">

      <div>
            <h4> Validando transaccion: </h4>
          </div>
          <div>
            <div>
              Transaccion : {{ idTransaccion }}
            </div>
            <span v-if="tipo == '1'">
              Numero predial nacionnal
            </span>
            <span v-if="tipo == '2'">
              Matricula Municipal
            </span>:
            {{ this.ref }}
          </div>
          <div>
            Liquidacion : {{ liq }}
          </div>
          <div>
            Estado : {{ estado }}
          </div>
          <div>
            Recibo caja : {{ recibo }}
          </div>
          <div>
            Valor : {{ valor | money }}
          </div>
          <div>
            Fecha transaccion : {{ fecha }}
          </div>

      <vue-html2pdf :show-layout="false" :enable-download="true" :preview-modal="true"
        :paginate-elements-by-height="1400" :filename="idTransaccion" :pdf-quality="2" pdf-format="a4"
        pdf-orientation="landscape" pdf-content-width="800px" @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)" ref="html2Pdf">
        <section slot="pdf-content">
          <div>
            <h4> Validando transaccion: </h4>
          </div>
          <div>
            <div>
              Transaccion : {{ idTransaccion }}
            </div>
            <span v-if="tipo == '1'">
              Numero predial nacionnal
            </span>
            <span v-if="tipo == '2'">
              Matricula Municipal
            </span>:
            {{ this.ref }}
          </div>
          <div>
            Liquidacion : {{ liq }}
          </div>
          <div>
            Estado : {{ estado }}
          </div>
          <div>
            Recibo caja : {{ recibo }}
          </div>
          <div>
            Valor : {{ valor | money }}
          </div>
          <div>
            Fecha transaccion : {{ fecha }}
          </div>
        </section>
      </vue-html2pdf>
      <div>
        <b-button class="mt-2" variant="primary" style="float: right;" @click="donwloadpdf"> Descargar PDF </b-button>
      </div>
    </div>

    <div v-if="!isValid">
      {{ msg }}
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: "Validate",
  components: {
    VueHtml2pdf
  },
  data: function () {
    return {
      estado: "",
      recibo: "",
      fecha: "",
      valor: 0,
      ref: "",
      liq: "",
      idTransaccion: "",
      tipo: "",
      isValid: false,
      msg: ""
    };
  },
  methods: {
    ...mapActions("pse", {
      loadValidatePSE: "loadValidatePSE",
    }),
    donwloadpdf() {
      this.$refs.html2Pdf.generatePdf();
    },
    async validatePagoPSE() {
      this.ref = localStorage.getItem("ref");
      this.liq = localStorage.getItem("liq");
      this.tipo = localStorage.getItem("tipo");
      this.idTransaccion = localStorage.getItem("id_transaccion");

      let responsePSE = await this.loadValidatePSE({
        ref: this.ref,
        liq: this.liq,
        tipoImp: this.tipo,
        IdTransaccion: this.idTransaccion
      });

      let status = responsePSE.data.status;
      if (responsePSE.status == 200 && status == "succes") {
        this.estado = responsePSE.data.data.transaccion;
        this.recibo = responsePSE.data.data.recibo;
        this.fecha = responsePSE.data.data.fecha_transaccion;
        this.liq = responsePSE.data.data.liq;
        this.valor = parseInt(responsePSE.data.data.valor);
        this.isValid = true;
      } else {
        this.isValid = false;
        this.msg = "No se pudo validar la transaccion, vuelve a intentarlo mas tarde.";
      }
    }
  },
  async mounted() {
    this.validatePagoPSE();
  }
  , filters: {
    money: function (value) {
      let val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>

<style></style>
